// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__a38Y8","questions":"styles_questions__3bFKk","footer":"styles_footer__1lPum"};